<template>
  <el-form ref="ff" v-loading="loading" :model="detail" label-width="100px">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-form-item label="关联库存" prop="Code">
          <el-autocomplete class="inline-input" style="width: 100%" clearable v-model="detail.Code" :fetch-suggestions="loadStock" placeholder="请输入ERP库存商品编码检索" @select="stockSelect">
            <div class="autoItem" slot-scope="{ item }">
              <p>{{ item.Code + '_' + item.TenantName + item.Warehouse }}</p>
              <p class="describe">{{ item.Name + (item.Spec || '') }}</p>
            </div>
          </el-autocomplete>
        </el-form-item>
      </el-col>
      <el-col :span="16">
        <el-form-item label="商品名称" prop="Name" required>
          <el-input v-model="detail.Name" clearable placeholder="建议：品牌+型号">
            <template slot="prepend">
              <metaPicker type="branch" :value.sync="detail.Stock" style="width: 100px" />
            </template>
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="8">
        <el-form-item label="状态" prop="State">
          <el-switch v-model="detail.State" active-text="上架" />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="销售单价" prop="Price" required>
          <el-input v-model="detail.Price" clearable>
            <template slot="prepend">￥</template>
          </el-input>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="计量单位" prop="Unit" required>
          <el-input v-model="detail.Unit" clearable />
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="商品简介">
      <el-input v-model="detail.Remark" type="textarea" rows="15" />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  components: {
    metaPicker: () => import("@/views/system/meta/item/_picker.vue")
  },
  data () {
    return {
      loading: false,
      detail: {},
    }
  },
  created () {
    let id = this.$route.params?.id
    if (id) {
      this.$apis.mall.goods.info({ id: id }).then(res => {
        if (res != null) {
          this.detail = res
        }
        else {
          this.$router.go(-1)
        }
      })
    }
    this.loadStock()
  },
  methods: {
    loadStock (key = null, cb) {
      this.$apis.product.stock.list({
        code: key,
        index: 1,
        size: 10
      }).then(res => {
        cb(res.Items)
      })
    },
    stockSelect (item) {
      this.detail.Stock = String(item?.CompanyId)
      this.detail.Code = item?.Code
      this.detail.Name = `${item?.Name}${item?.Spec}`
      this.detail.Unit = item?.Unit
    },
    //提交数据
    onSubmit () {
      this.$refs['ff'].validate(valid => {
        if (valid && !this.loading) {
          this.loading = true
          //处理数组
          this.$apis.mall.goods.submit(this.detail).then(res => {
            this.$message({ message: "数据提交成功！", type: "success" })
            this.$router.replace({ path: `/mall/goods/form/${res.Id}` })
          }).catch(e => {
            this.$message.error(e || "执行错误")
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>


<style lang="scss" scoped>
.autoItem {
  line-height: 1;
  margin: 10px 0;
}
</style>